import { supabase } from '../lib/supabase';
import { traduzirErroAdmin } from '../lib/erroAdmin';

export type Modulo = 'jukebox' | 'futebol' | 'pdv' | 'identidade_sonora' | 'whatsapp' | 'anunciantes';

export interface PlanoModulo {
  plano_slug: string;
  plano_nome: string;
  preco_mensal: number;
  modulo: Modulo;
}

export const modulosService = {
  async meusModulos(): Promise<Modulo[]> {
    const { data, error } = await supabase.rpc('meus_modulos' as never);
    if (error) throw traduzirErroAdmin(error);
    return (data ?? []) as Modulo[];
  },

  async planosPorModulo(): Promise<PlanoModulo[]> {
    const { data, error } = await supabase.rpc('planos_modulos_publico' as never);
    if (error) throw traduzirErroAdmin(error);
    return (data ?? []) as PlanoModulo[];
  },
};
